<template>
  <div>
    <b-modal id="modalEditSharedNetworks" ref="modalEditSharedNetworks" :title="$t('Shared network')" hide-footer size="lg">
      <div v-if="editItem">
        <b-tabs pills content-class="mt-3">
          <b-tab :title="$t('Main')" active>
            <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="editItem.name"/>
            </b-form-group>
            <b-form-group label-align="right" label="Valid life time" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="number" v-model="editItem['valid-lifetime']"/>
            </b-form-group>
            <b-form-group label-align="right" label="Interface" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="editItem.interface"/>
            </b-form-group>
            <b-form-group label="Relay" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-button class="mb-1" variant="success" size="sm" style="float: right; width: 100px" @click="addIpAdress">{{ $t('Add') }}</b-button>
            </b-form-group>

            <b-card>
              <b-row>
                <b-col cols="6">
                  <h5>{{ $t('IPv6 addresses') }}</h5>
                </b-col>
                <b-col cols="4"/>
                <b-col>
                  <h5>{{ $t('Delete') }}</h5>
                </b-col>
              </b-row>

              <b-row v-for="item in this.editItem.relay.ip_addresses" v-bind:key="item.num">
                <b-col cols="6">
                  <b-form-input type="text" v-model="item.adress"/>
                </b-col>
                <b-col cols="4"/>
                <b-col>
                  <b-button size="sm" id="transparent" @click="deleteIpAdress(item)">
                    <b-img :src='deleteImage'/>
                  </b-button>
                </b-col>
              </b-row>
            </b-card>

          </b-tab>
          <b-tab :title="$t('Option-data tab')">
            <b-form-group>
              <b-button class="mb-1" variant="success" size="sm" style="width: 100px" @click="swohAddOptionData">{{ $t('Add') }}</b-button>
            </b-form-group>
            <b-table small striped hover :items="editItem['option-data']" :fields="optionDataFields">
              <template v-slot:cell(actions)="row">
                <b-button size="sm" @click.stop="editOptionData(row)" id="transparent">
                  <b-img :src='editImage'/>
                </b-button>
                <b-button size="sm" @click.stop="deleteOptionData(row)" id="transparent">
                  <b-img :src='deleteImage'/>
                </b-button>
              </template>
            </b-table>
          </b-tab>
          <b-tab :title="$t('Subnets')">
            <b-form-group>
              <b-button class="mb-1" variant="success" size="sm" style="width: 100px" @click="swohAddSubnets">{{ $t('Add') }}</b-button>
            </b-form-group>
            <b-table small striped hover :items="editItem.subnet6" :fields="subnetFields">
              <template v-slot:cell(actions)="row">
                <b-button size="sm" @click.stop="editSubnets(row)" id="transparent">
                  <b-img :src='editImage'/>
                </b-button>
                <b-button size="sm" @click.stop="deleteSubnets(row)" id="transparent">
                  <b-img :src='deleteImage'/>
                </b-button>
              </template>
            </b-table>
          </b-tab>
        </b-tabs>

        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="save">{{ $t('Save')}}</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalEditSharedNetworks.hide">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>

    <b-modal id="modalSubnet" ref="modalSubnet" :title="$t('Subnet')" hide-footer size="lg">
      <b-form-group label-align="right" :label="$t('Subnet')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="text" v-model="selectSubnet.subnet" aria-describedby="inputFeedbackSubnet" :state="selectSubnet.subnet.length > 0"/>
        <b-form-invalid-feedback id="inputFeedbackSubnet">
            {{ $t('Enter IPv6') }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group :label="$t('Pools')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-button class="mb-1" variant="success" size="sm" style="float: right; width: 100px" @click="swohAddPools">{{ $t('Add') }}</b-button>
      </b-form-group>
      <b-table small striped hover :items="selectSubnet.pools" :fields="poolsFields">
        <template v-slot:cell(actions)="row">
          <b-button size="sm" @click.stop="editPools(row)" id="transparent">
            <b-img :src='editImage'/>
          </b-button>
          <b-button size="sm" @click.stop="deletePools(row)" id="transparent">
            <b-img :src='deleteImage'/>
          </b-button>
        </template>
      </b-table>
      <b-form-group :label="$t('Option-data')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-button class="mb-1" variant="success" size="sm" style="float: right; width: 100px" @click="swohAddOptionDataSubnet">{{ $t('Add') }}</b-button>
      </b-form-group>
      <b-table small striped hover :items="selectSubnet['option-data']" :fields="optionDataFields">
        <template v-slot:cell(actions)="row">
          <b-button size="sm" @click.stop="editOptionDataSubnet(row)" id="transparent">
            <b-img :src='editImage'/>
          </b-button>
          <b-button size="sm" @click.stop="deleteOptionDataSubnet(row)" id="transparent">
            <b-img :src='deleteImage'/>
          </b-button>
        </template>
      </b-table>

      <b-row>
        <b-col>
          <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="addSubnet">Ok</b-button>
        </b-col>
        <b-col sm="1.5">
          <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalSubnet.hide">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal hide-footer ref="modalPools" id="modalPools" :title="$t('Pools')">
      <b-form-group label-align="right" :label="$t('Pool')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-input-group>
          <b-form-input type="text" v-model="selectPools.pool" aria-describedby="inputFeedbackPool" :state="selectPools.pool.length > 0"/>
          <b-input-group-append>
            <span id="tooltip">
              <b-img :src="questionImage"/>
            </span>
            <b-tooltip target="tooltip" triggers="hover">
              {{ $t('Examples: cafe::/96, cafe::0-cafe-::10') }}
            </b-tooltip>
          </b-input-group-append>
          <b-form-invalid-feedback id="inputFeedbackPool">
              {{ $t('Enter IPv6') }}
          </b-form-invalid-feedback>
        </b-input-group>
      </b-form-group>

      <b-row>
        <b-col>
          <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="addPools">Ok</b-button>
        </b-col>
        <b-col sm="1.5">
          <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalPools.hide">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-modal>

    <modalOptionData
      :selectSubnet="selectSubnet"
      :editItem="editItem"
      :selectOptionData="selectOptionData"/>
  </div>
</template>

<script>
import modalOptionData from '@/pages/settings/DHCPv6/modalOptionData'

export default {
  components: {
    modalOptionData
  },
  props: {
    sharedNetworks: null,
    editItem: null,
    isEdit: null
  },
  data () {
    return {
      selectPools: {
        'pool': ''
      },
      selectSubnet: {
        'id': 0,
        'subnet': '',
        'pools': [],
        'option-data': []
      },
      selectOptionData: {
        'name': '',
        'code': '',
        'space': 'dhcp6',
        'csv-format': false,
        'data': ''
      },
      numPools: 1000000,
      numAdress: 1000000,
      questionImage: require('@/assets/img/question.png'),
      editImage: require('@/assets/img/document_edit.png'),
      deleteImage: require('@/assets/img/document_delete.png'),
      optionDataFields: [
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'code', label: this.$i18n.t('Code'), sortable: true},
        {key: 'space', label: this.$i18n.t('Space'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      subnetFields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'subnet', label: this.$i18n.t('Subnet'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      poolsFields: [
        {key: 'pool', label: this.$i18n.t('Pool'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ]
    }
  },
  methods: {
    async save () {
      let copy = JSON.parse(JSON.stringify(this.editItem))
      let DHCPv6 = JSON.parse(JSON.stringify(this.$store.getters['Settings/DHCPV6']))
      let sharedNetworks = {
        'is_test_only': true,
        'loop_count_timeout': 35,
        'config': {}
      }
      for (let el of this.editItem.subnet6) {
        delete el.isEdit
        delete el.isSubnet
        for (let elPools of el.pools) {
          delete elPools.numPools
          delete elPools.isEdit
        }
        for (let elOptionData of el['option-data']) {
          delete elOptionData.numOptionData
          delete elOptionData.isEdit
        }
      }
      for (let el of this.editItem['option-data']) {
        delete el.numOptionData
        delete el.isEdit
      }
      let ipAdress = []
      for (let el of this.editItem.relay.ip_addresses) {
        ipAdress.push(el.adress)
      }
      delete this.editItem.relay.ip_addresses
      if (this.isEdit) {
        for (let el of this.sharedNetworks) {
          if (el.num === this.editItem.num) {
            el.relay['ip-addresses'] = ipAdress
            el.name = this.editItem.name
            el['valid-lifetime'] = Number(this.editItem['valid-lifetime'])
            el.interface = this.editItem.interface
            el['option-data'] = this.editItem['option-data']
            el.subnet6 = this.editItem.subnet6
          }
        }
        DHCPv6.arguments.Dhcp6['shared-networks'] = this.sharedNetworks
      } else {
        this.editItem.relay['ip-addresses'] = ipAdress
        this.editItem['valid-lifetime'] = Number(this.editItem['valid-lifetime'])
        DHCPv6.arguments.Dhcp6['shared-networks'].push(this.editItem)
      }
      for (let el of DHCPv6.arguments.Dhcp6['shared-networks']) {
        delete el.num
      }
      sharedNetworks.config = DHCPv6.arguments
      await this.$store.dispatch('Settings/SAVE_DHCPV6', sharedNetworks).then(response => {
        if (response.data.result === 0) {
          sharedNetworks.is_test_only = false
          let response = this.$store.dispatch('Settings/SAVE_DHCPV6', sharedNetworks)
          response.then(response => {
            if (response.data.error) {
              this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
            } else {
              this.$store.dispatch('Settings/SAVE_CONFIG_DHCPV6')
              setTimeout(this.$store.dispatch, 500, 'Settings/GET_DHCPV6')
              this.$refs.modalEditSharedNetworks.hide()
              this.$root.$emit('makeToasts')
            }
          })
        } else {
          this.editItem = copy
          this.$root.$emit('makeToasts', 'danger', response.data.text, 'Error')
        }
      })
    },
    addIpAdress () {
      let newEl = {
        num: 0,
        adress: ''
      }
      newEl.num = ++this.numAdress
      this.editItem.relay.ip_addresses.push(newEl)
    },
    deleteIpAdress (row) {
      this.editItem.relay.ip_addresses = this.editItem.relay.ip_addresses.filter((value) => {
        return value.num !== row.num
      })
    },
    swohAddOptionData () {
      this.selectOptionData = {
        'numOptionData': 0,
        'isEdit': false,
        'name': '',
        'code': '',
        'space': 'dhcp6',
        'csv-format': false,
        'data': ''
      }
      this.selectSubnet = {
        'isSubnet': false,
        'id': 0,
        'isEdit': false,
        'subnet': '',
        'pools': [],
        'option-data': []
      }
      this.$root.$emit('bv::show::modal', 'modalOptionData', '#btnShow')
    },
    editOptionData (row) {
      this.selectOptionData = JSON.parse(JSON.stringify(row.item))
      this.selectOptionData.isEdit = true
      this.selectSubnet = {
        'isSubnet': false,
        'id': 0,
        'isEdit': false,
        'subnet': '',
        'pools': [],
        'option-data': []
      }
      this.$root.$emit('bv::show::modal', 'modalOptionData', '#btnShow')
    },
    deleteOptionData (row) {
      this.editItem['option-data'] = this.editItem['option-data'].filter((value) => {
        return value !== row.item
      })
    },
    swohAddSubnets () {
      this.selectSubnet = {
        'isSubnet': true,
        'id': 0,
        'isEdit': false,
        'subnet': '',
        'pools': [],
        'option-data': []
      }
      this.$root.$emit('bv::show::modal', 'modalSubnet', '#btnShow')
    },
    editSubnets (row) {
      this.selectSubnet = JSON.parse(JSON.stringify(row.item))
      this.selectSubnet.isSubnet = true
      this.selectSubnet.isEdit = true
      this.$root.$emit('bv::show::modal', 'modalSubnet', '#btnShow')
    },
    deleteSubnets (row) {
      this.editItem.subnet6 = this.editItem.subnet6.filter((value) => {
        return value !== row.item
      })
    },
    addSubnet () {
      if (!this.selectSubnet.subnet) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect IP format'), 'Error')
        return
      }

      if (this.selectSubnet.isEdit) {
        for (let el of this.editItem.subnet6) {
          if (el.id === this.selectSubnet.id) {
            el.subnet = this.selectSubnet.subnet
            el.pools = this.selectSubnet.pools
            el['option-data'] = this.selectSubnet['option-data']
          }
        }
      } else {
        let DHCPv6 = JSON.parse(JSON.stringify(this.$store.getters['Settings/DHCPV6']))
        let id = [0]
        if (DHCPv6.arguments.Dhcp6.subnet6.length > 0) {
          for (let el of DHCPv6.arguments.Dhcp6.subnet6) {
            id.push(el.id)
          }
        }
        for (let el of DHCPv6.arguments.Dhcp6['shared-networks']) {
          if (el.subnet6.length > 0) {
            for (let elSub of el.subnet6) {
              id.push(elSub.id)
            }
          }
        }
        this.selectSubnet.id = Math.max.apply(null, id) + 1
        this.editItem.subnet6.push(this.selectSubnet)
      }
      this.$refs.modalSubnet.hide()
    },
    swohAddPools () {
      this.selectPools = {
        isEdit: false,
        pool: ''
      }
      this.$root.$emit('bv::show::modal', 'modalPools', '#btnShow')
    },
    editPools (row) {
      this.selectPools = JSON.parse(JSON.stringify(row.item))
      this.selectPools.isEdit = true
      this.$root.$emit('bv::show::modal', 'modalPools', '#btnShow')
    },
    deletePools (row) {
      this.selectSubnet.pools = this.selectSubnet.pools.filter((value) => {
        return value !== row.item
      })
    },
    addPools () {
      if (!this.selectPools.pool) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect IP format'), 'Error')
        return
      }

      if (this.selectPools.isEdit) {
        for (let el of this.selectSubnet.pools) {
          if (this.selectPools.numPools === el.numPools) {
            el.pool = this.selectPools.pool
          }
        }
      } else {
        this.selectPools.numPools = ++this.numPools
        this.selectSubnet.pools.push(this.selectPools)
      }
      this.$refs.modalPools.hide()
    },
    swohAddOptionDataSubnet () {
      this.selectOptionData = {
        'numOptionData': 0,
        'isEdit': false,
        'name': '',
        'code': '',
        'space': 'dhcp6',
        'csv-format': false,
        'data': ''
      }
      this.$root.$emit('bv::show::modal', 'modalOptionData', '#btnShow')
    },
    editOptionDataSubnet (row) {
      this.selectOptionData = JSON.parse(JSON.stringify(row.item))
      this.selectOptionData.isEdit = true
      this.$root.$emit('bv::show::modal', 'modalOptionData', '#btnShow')
    },
    deleteOptionDataSubnet (row) {
      this.selectSubnet['option-data'] = this.selectSubnet['option-data'].filter((value) => {
        return value !== row.item
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/DHCPv6/sharedNetworks/editModal.vue